import { Sidebar, Menu } from '@wework/dieter-ui'
import React, { useState } from 'react'
import { useSidebar } from '../../hoc/withSidebar'
import IMTheme from '../../style/IMTheme'
import BuildingInfo from './BuildingInfo'
import BuildingInfoProducts from './BuildingInfoProducts'
import BuildingInfoSpaces from './BuildingInfoSpaces'
import BuildingInfoNotLinked from './BuildingInfoNotLinked'
import BulkActionsDrawer from './BulkActionsDrawer'
import DeskLinkeage from './DeskLinkeage'
import DownloadPlans from './DownloadPlans'
import EditDrawer from './EditDrawer'
import InternalRoomsDrawer from './InternalRoomsDrawer'
import InventoryDrawer from './InventoryDrawer'
import Legend from './Legend'
import LinkRoom from './LinkRoom'
import SearchResultDrawer from './SearchResultDrawer'

function SideBar({
  zIndex,
  offsetTop,
  spaces,
  onHoldHandler,
  spaceSetter,
  noteModalHandler,
  selectedInternals,
  deselectAllInternals,
  deselectInternalRoom,
  multiple,
  multiDeskSetter,
  multipleDeskLink,
  multipleSetter,
  handleSearchResultClick,
  handleMouseOutSpaceList,
  handleMouseOverSpaceList,
  currentFloorUUID,
  currentBuildingUUID,
  currentBuilding,
  setSelectedInternalRooms,
  searchResult = [],
  allSpaces = [],
}) {
  const { isOpen, sideBarName, closeSideBar } = useSidebar()
  const [isExpanded, setIsExpanded] = useState(false)
  if (!sideBarName) return <></>

  if (sideBarName === 'MultiSelect' && spaces.length === 0) return <> </>
  if (
    (sideBarName === 'InventoryDrawer' ||
      sideBarName === 'EditDrawer' ||
      sideBarName === 'Linkeage') &&
    spaces.length === 0
  )
    return <></>

  const isProductVisible =
    sideBarName === 'InventoryDrawer' && !!spaces[0]?.inventoryData

  const getWidth = () => {
    switch (sideBarName) {
      case 'BuildingInfo':
      case 'BuildingInfoSpaces':
      case 'BuildingInfoProducts':
      case 'BuildingInfoNotLinked':
      case 'Legend':
      case 'InternalRooms':
      case 'DownloadPlans':
        return 290
      case 'MultiSelect':
        if (isExpanded) return '100%'
        return 558
      case 'InventoryDrawer':
        return isProductVisible ? 666 : 302

      default:
        return 558
    }
  }

  const getHeader = () => {
    switch (sideBarName) {
      case 'InventoryDrawer':
        return <></>
      case 'EditDrawer':
        return <></>
      case 'Linkeage':
        return <></>
      default:
        return <></>
    }
  }
  const getContent = () => {
    switch (sideBarName) {
      case 'InventoryDrawer':
        return (
          <InventoryDrawer
            handleInternalRoomClick={handleSearchResultClick}
            space={spaces[0]}
            isProductVisible={isProductVisible}
            currentBuilding={currentBuilding}
            onHoldClick={onHoldHandler}
            noteModalHandler={noteModalHandler}
          />
        )
      case 'EditDrawer':
        return <EditDrawer space={spaces[0]} />
      case 'Linkeage':
        return <LinkRoom spaces={spaces} />
      case 'DeskLinkeage':
        return (
          <DeskLinkeage spaces={spaces} multiDeskSetter={multiDeskSetter} />
        )
      case 'BuildingInfo':
        return <BuildingInfo />
      case 'BuildingInfoSpaces':
        return <BuildingInfoSpaces />
      case 'BuildingInfoProducts':
        return <BuildingInfoProducts />
      case 'BuildingInfoNotLinked':
        return <BuildingInfoNotLinked />
      case 'Legend':
        return <Legend />
      case 'DownloadPlans':
        return <DownloadPlans buildingId={currentBuildingUUID} />
      case 'MultiSelect':
        return (
          <BulkActionsDrawer
            spaces={spaces}
            isExpanded={isExpanded}
            setIsExpanded={setIsExpanded}
            onHoldHandler={onHoldHandler}
            spaceSetter={spaceSetter}
            onClose={() => {
              closeSideBar()
              spaceSetter([])
              multipleSetter(false)
            }}
          />
        )
      case 'InternalRooms':
        return (
          <InternalRoomsDrawer
            onDeselect={room => {
              deselectInternalRoom(room)
            }}
            deselectAll={deselectAllInternals}
            space={spaces[0] || null}
            selectedInternalRooms={selectedInternals}
            setSelectedInternalRooms={setSelectedInternalRooms}
          />
        )
      case 'SpaceList':
        return (
          <SearchResultDrawer
            spaces={allSpaces}
            currentFloorUUID={currentFloorUUID}
            onClick={handleSearchResultClick}
            onMouseOver={handleMouseOverSpaceList}
            onMouseOut={handleMouseOutSpaceList}
          />
        )
      case 'SearchDrawer':
        return (
          <SearchResultDrawer
            spaces={searchResult || allSpaces}
            currentFloorUUID={currentFloorUUID}
            onClick={handleSearchResultClick}
            onMouseOver={handleMouseOverSpaceList}
            onMouseOut={handleMouseOutSpaceList}
          />
        )

      default:
        return <></>
    }
  }
  const baseStyle = {
    zIndex: zIndex,
    overflowY: 'hidden!important',
    backgroundColor: 'white',
    position: 'absolute',
    width: getWidth(),
    display: 'flex',
    flexDirection: 'column',
    top: offsetTop,
    maxHeight: `calc(100% - (16px + ${offsetTop}px))`,
  }
  const customStyle = {
    ...baseStyle,
    paddingTop: IMTheme.spacing[3],
    paddingRight: IMTheme.spacing[4],
    paddingLeft: IMTheme.spacing[4],
    paddingBottom: IMTheme.spacing[4],
    backgroundColor: '#00000000',
    boxShadow: 'none',
    border: 'none',
  }
  return (
    <Sidebar
      animation="overlay"
      visible={isOpen}
      direction="right"
      as={Menu}
      style={sideBarName !== 'InventoryDrawer' ? baseStyle : customStyle}
    >
      {getHeader()}
      {getContent()}
    </Sidebar>
  )
}

export default SideBar
